import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "@env/environment";
import { OrdonnanceSelAmcTool, ReponseSelAmc } from "@jack-sparrow-libraries/emotion-models";
import { AnnuaireAmcUrl } from "@models/selamc.models";
import { MutuelleAttestationPatient } from "@jack-sparrow-libraries/emotion-models/lib/emotion.model";

@Injectable({
	providedIn: "root",
})
export class SelamcApiService {
	constructor(private http: HttpClient) {}

	saveUrlAmc(annuaireAmcUrl: AnnuaireAmcUrl) {
		const headers = new HttpHeaders().set("Content-Type", "application/json");
		return this.http.post<AnnuaireAmcUrl>(
			`${environment.apiEmotion()}/tlsi/selamc/annuaire/cache/url`,
			annuaireAmcUrl,
			{
				headers,
			},
		);
	}

	callServiceIdb(ordonnanceSelAmcTool: OrdonnanceSelAmcTool, situationId: number) {
		const headers = new HttpHeaders().set("Content-Type", "application/json");
		return this.http.post<ReponseSelAmc>(
			`${environment.apiEmotion()}/tlsi/selamc/idb/appel/ordonnnanceTool/${situationId}`,
			ordonnanceSelAmcTool,
			{
				headers,
			},
		);
	}

	traiteReponseSelAmcIdb(reponseSelAmc: ReponseSelAmc) {
		const headers = new HttpHeaders().set("Content-Type", "application/json");
		return this.http.post<MutuelleAttestationPatient>(
			`${environment.apiEmotion()}/mutuelleAttestationPatientSelAmc/traite/reponse/idb`,
			reponseSelAmc,
			{
				headers,
			},
		);
	}

	consulterConventionDepuisAnnuaireAmc(situationId: number, amc: string, typeConv: string, csr, service: string) {
		const headers = new HttpHeaders().set("Content-Type", "application/json");
		return this.http.post<ReponseSelAmc>(
			`${environment.apiEmotion()}/tlsi/selamc/consulterConventionAnnuaireAmc?situationId=${situationId}&numAmc=${amc}&codeConvention=${typeConv}&csr=${csr}&serviceAmc=${service}`,
			{
				headers,
			},
		);
	}
}
